var render = function render(){var _vm=this,_c=_vm._self._c;return _c('strong',{domProps:{"innerHTML":_vm._s(_vm.headline)}})
}
var staticRenderFns = []

export { render, staticRenderFns }